import { Injectable } from '@angular/core';
import {ModalService} from "./modal.service";
import {paramsHelper} from "../helpers/params-helper";
import {ITEM_ID_TYPE} from "../enums/enums";
import {Subject} from "rxjs/Subject";
import {JP} from "../helpers/jp";
import * as _ from "underscore";
import {WatchService} from "./watch.service";
import {Observable} from "rxjs/Observable";
import {IDocument} from "../interfaces/document.definition";


@Injectable()
export class PickService {

  constructor(private modalService: ModalService,
              private watchService: WatchService) { }


  pickQuestAndActivate(document:IDocument){
    const subject = new Subject<boolean>();

    this.modalService.showSelector22(paramsHelper.modalCollectionConfig(ITEM_ID_TYPE.QUEST))
      .subscribe(quest => {
        subject.next(this.activateQuest(document, quest));
      });

    return subject.asObservable().first();
  }

  pickIdAndPushToArray(target: IDocument,
                       pointer: string,
                       itemType: ITEM_ID_TYPE): Observable<boolean> {
    const subject = new Subject<boolean>();

    this.modalService.showSelector22(paramsHelper.modalCollectionConfig(itemType))
      .subscribe(document => {
        subject.next(this.pushDocumentIdToArrayInsideTarget(target, document, pointer));
      });

    return subject.asObservable().first();
  }

  private activateQuest(document:IDocument, quest:IDocument):boolean{
    var activeQuestsPtr:string = 'quests';
    let activeQuests = document[activeQuestsPtr];
    console.log(activeQuests);

    for (var i = 0; i < activeQuests.length; i ++)
    {
      let q:IDocument = activeQuests[i];
      if (q.id == quest.id)
      {
        return false;
      }
    }

    var tQuest = {
      id:quest.id,
      stages:[],
      opened:false,
      receiveTime:Date.now() * 0.001,
      receiveGameTime:0,
      deactivateTime:0
    }
    for (let j = 0; j <= quest['stages'].length; j ++)
    {
      tQuest.stages.push(0);
    }

    activeQuests.push(tQuest);
    console.log(activeQuests);
    this.watchService.notify();
    return true;
  }



  private pushDocumentIdToArrayInsideTarget(target:IDocument, document:IDocument, pointer: string):boolean {
    let array = null;
    if (JP.has(target, pointer) && _.isArray(JP.get(target, pointer))) {
      array = JP.get(target, pointer);
    } else {
      array = []; /* creates array and set to object */
      JP.set(target, pointer, array);
    }

    if (_.contains(array, document.id)) {
      return false;
    }

    array.push(document.id);
    this.watchService.notify();
    return true;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/pick.service.ts